import { useMutation } from "@tanstack/react-query";
import axios from "axios";

import { UploadToS3Request } from "../directUpload.types";

const fetcher = async ({ url, body }: UploadToS3Request) => {
  return await axios.put(url, body, {
    headers: {
      "Content-Type": body.type
    }
  });
};

export const useUploadToS3 = () => {
  return useMutation(fetcher);
};
